import {
  organization_pharmacy_create,
  organization_my_list,
  organization_insurance_list,
  organization_pharmacy_list,
  organization_pharmacy_public_read,
  organization_internationaltradeconfiguration_read,
} from "@/lib/api-client.js";
import { getAxiosConfig as axconf } from "@/lib/api-config.js";
import { getAxiosConfigNoAuth as axconfNoAuth } from "@/lib/api-config.js";

import Vue from "vue";

export default {
  namespaced: true,
  state: {
    profiles: {
      pharmacist: {
        uuid: null,
      },
      insuranceworker: {
        uuid: null,
      },
    },
    international_trade_config: undefined,
    mine_pharmacies: [],
    mine_insurances: [],
    insurance_list: [],
    is_insurance_list_loaded: false,
  },
  actions: {
    // get those organizations that current user can manage
    MINE: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit("MUTATE_MINE", []);
        organization_my_list({
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            commit("MUTATE_MINE", response.data.results);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    // get a list of available insurances
    // TODO: implements pagination behavior
    INSURANCE_LIST: ({ commit }) => {
      return new Promise((resolve, reject) => {
        organization_insurance_list({
          role: "vooyguest",
          roleUuid: "1",
          $config: axconf(),
        }).then(
          response => {
            commit("MUTATE_INSURANCE_LIST", response.data.results);
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    NEW_PHARMACY: (undefined, payload) => {
      return new Promise((resolve, reject) => {
        organization_pharmacy_create({
          data: payload.data,
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    GET_PHARMACY: (undefined, payload) => {
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        organization_pharmacy_public_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          uuid: payload.uuid,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_PHARMACIES: (undefined, payload) => {
      const offset = payload.per_page * (payload.current_page - 1);
      return new Promise((resolve, reject) => {
        organization_pharmacy_list({
          $config: axconfNoAuth(),
          role: "vooyguest",
          roleUuid: "1",
          offset: offset,
          limit: payload.per_page,
          uuid: payload.uuid,
          country: payload.country,
          withPubPricesToCountry: payload.with_pub_prices_to_country,
          publicName: payload.pharmacy,
        }).then(
          response => {
            resolve(response);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    REQUEST_INTERNATIONAL_TRADE_CONFIG: ({ commit }) => {
      return new Promise((resolve, reject) => {
        organization_internationaltradeconfiguration_read({
          $config: axconf(),
          role: "vooyguest",
          roleUuid: "1",
        }).then(
          response => {
            commit("MUTATE_INTERNATIONAL_TRADE_CONFIG", response.data);
            resolve(response);
          },
          err => {
            commit("MUTATE_INTERNATIONAL_TRADE_CONFIG", null);
            reject(err);
          }
        );
      });
    },
  },
  mutations: {
    SET_PHARMACIST_UUID: (state, uuid) => {
      //localStorage.setItem('jwt', jwt_access);
      state.profiles.pharmacist.uuid = uuid;
    },
    // foreach api result (a list of organizations)
    // and store separately pharmacies and insurances
    // TYPE_INSURANCE_COMPANY = 1
    // TYPE_PHARMACY_COMPANY = 2
    // TYPE_LABORATORY_COMPANY = 3
    MUTATE_MINE: (state, mine) => {
      var pharmacies = [];
      var insurances = [];
      mine.forEach(function(org) {
        if (org.type == 2) {
          pharmacies.push(org);
        } else if (org.type == 1) {
          insurances.push(org);
        }
      });
      Vue.set(state, "mine_pharmacies", pharmacies);
      Vue.set(state, "mine_insurances", insurances);
    },
    MUTATE_INSURANCE_LIST: (state, list) => {
      Vue.set(state, "insurance_list", list);
      Vue.set(state, "is_insurance_list_loaded", true);
    },
    MUTATE_INTERNATIONAL_TRADE_CONFIG: (state, payload) => {
      state.international_trade_config = Object.assign({}, payload);
    },
  },
  getters: {
    isInsuranceListLoaded: state => {
      return state.is_insurance_list_loaded;
    },
    isPharmacistProfileLoaded: state => {
      return state.profiles.pharmacist.uuid != null;
    },
    getPharmacyDataByUUID: state => p_uuid => {
      var found_org = null;
      state.mine_pharmacies.forEach(function(org) {
        if (org.uuid == p_uuid) {
          found_org = org;
        }
      });
      return found_org;
    },
    getInsuranceDataByUUID: state => i_uuid => {
      var found_org = null;
      state.insurance_list.forEach(function(org) {
        if (org.uuid == i_uuid) {
          found_org = org;
        }
      });
      return found_org;
    },
  },
};
